/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Lv_Need_RefsInputs */

const cs_property_registry_lv_need_refs = /** @type {(inputs: Property_Registry_Lv_Need_RefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stačí číslo LV + kód katastrálního území, nebo samotné ID LV.`)
};

const en_property_registry_lv_need_refs = /** @type {(inputs: Property_Registry_Lv_Need_RefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provide LV number + cadastral area code, or LV ID alone.`)
};

/**
* | output |
* | --- |
* | "Provide LV number + cadastral area code, or LV ID alone." |
*
* @param {Property_Registry_Lv_Need_RefsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_lv_need_refs = /** @type {((inputs?: Property_Registry_Lv_Need_RefsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Lv_Need_RefsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_lv_need_refs(inputs)
	return cs_property_registry_lv_need_refs(inputs)
});